import { styled, css } from 'styled-components';

export const Container = styled.div`
  ${() => css`
    align-items: flex-start;
    display: flex;
    gap: 0.75rem;
    padding: 0;

    .ds-tooltip-wrapper {
      line-height: 1em;
    }

    &:hover {
      .status-area {
        margin-right: 0;

        .button {
          opacity: 1;
          visibility: visible;
        }
      }
    }
  `}
`;

export const Avatar = styled.div<{ $useBackground: boolean }>`
  ${({ theme: { colors }, $useBackground }) => css`
    align-items: center;
    background: ${$useBackground ? colors.brandPrimary : 'transparent'};
    border-radius: 0.25rem;
    display: flex;
    flex: 0 0 auto;
    height: 1.5rem;
    justify-content: center;
    position: relative;
    width: 1.5rem;

    .skeleton {
      border-radius: 0.25rem;
    }

    ${
      $useBackground &&
      css`
        &::before {
          border-radius: inherit;
          box-shadow: inset 0 0 0 1px ${colors.brandDarkAlpha20};
          content: '';
          display: block;
          height: 100%;
          left: 0;
          pointer-events: none;
          position: absolute;
          top: 0;
          user-select: none;
          width: 100%;
          z-index: 1;
        }
      `
    }

    img {
      border-radius: 0.25rem;
      height: 100%;
      object-fit: cover;
      width: 100%;
    }
  `}
`;

export const NetworkBadge = styled.div`
  ${({ theme: { colors } }) => css`
    align-items: center;
    background: ${colors.brandLight};
    border-radius: 0.5rem;
    bottom: -0.375rem;
    box-shadow: 0 0 0 2px ${colors.brandLight};
    display: flex;
    height: 1rem;
    justify-content: center;
    position: absolute;
    right: -0.375rem;
    width: 1rem;
    z-index: 1;

    .icon {
      height: 0.875rem;
      width: 0.875rem;
      padding: 0;
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 0;
  overflow: hidden;
  place-self: center;
`;

export const ContentTop = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const StatusArea = styled.div<{ $isSummaryVersion: boolean }>`
  ${({ theme: { colors, fontSizes }, $isSummaryVersion }) => css`
    align-items: center;
    display: flex;
    justify-content: ${$isSummaryVersion ? 'flex-end' : 'center'};
    margin-right: -1.5rem;
    transition: all 0.15s ease-in-out;

    .button {
      opacity: 0;
      transition: all 0.15s ease-in-out;
      visibility: hidden;
    }

    .mark-as-read-button {
      margin-right: -0.5rem;
    }

    .repost-button {
      margin-left: 0.5rem;
    }

    .ds-tooltip-wrapper {
      align-items: center;
      display: flex;
      justify-content: center;
      margin: 0;
    }

    .status-icon {
      color: ${colors.semanticSuccess};
      height: 1.125rem;
      width: 1.125rem;
    }

    span {
      color: ${colors.brandDarkTint30};
      flex-shrink: 0;
      font-size: ${fontSizes.s12};
      font-style: italic;
      letter-spacing: 0.03em;
      user-select: none;
    }
  `}
`;

export const ErrorBox = styled.div<{ $isSummaryVersion: boolean; $isResolved: boolean }>`
  ${({ theme: { colors, fontSizes }, $isSummaryVersion, $isResolved }) => css`
    background: ${$isResolved ? colors.brandDarkTint90 : colors.semanticDangerTint90};
    border: 1px solid ${$isResolved ? ' transparent' : colors.semanticDangerTint80};
    border-radius: 0.5rem;
    padding: 0.5rem 0.75rem;

    p {
      color: ${$isResolved ? colors.brandDarkTint20 : colors.semanticDangerShade20};
      font-size: ${fontSizes.s12};
    }

    a {
      text-decoration: underline;
      word-break: break-all;
    }

    ${
      $isSummaryVersion &&
      css`
        align-items: center;
        display: flex;
        gap: 3rem;
        justify-content: space-between;
        padding: 0.25rem 0.75rem;

        p {
          line-height: 1.2em;
        }
      `
    }
  `}
`;
